module.exports = __webpack_public_path__ + "img/13.1b0e4741.png";